export const VOIP_NUMBER_POOL_MODULE_NAME = "voipNumberPool";

export const VOIP_NUMBER_POOL_CLEAR_STATE = "clear";
export const VOIP_NUMBER_POOL_SET_PROVINCE = "setProvince";
export const VOIP_NUMBER_POOL_SET_AVAILABLE_NUMBERS = "setAvailableNumber";
export const VOIP_NUMBER_POOL_SET_PREFIXES = "setPrefixes";

export const VOIP_NUMBER_POOL_GET_PREFIXES = "getPrefixes";

export const VOIP_NUMBER_POOL_FETCH_AVAILABLE_NUMBERS_ACTION = "fetchAvailableNumbers";
export const VOIP_NUMBER_POOL_FETCH_PREFIXES_ACTION = "fetchPrefixes";
export const VOIP_NUMBER_POOL_RESERVE_NUMBER_ACTION = "reserveNumber";

export const VoipNumberPoolStoreActions = {
	FETCH_AVAILABLE_NUMBERS: `${VOIP_NUMBER_POOL_MODULE_NAME}/${VOIP_NUMBER_POOL_FETCH_AVAILABLE_NUMBERS_ACTION}`,
	FETCH_PREFIXES: `${VOIP_NUMBER_POOL_MODULE_NAME}/${VOIP_NUMBER_POOL_FETCH_PREFIXES_ACTION}`,
	RESERVE_NUMBER: `${VOIP_NUMBER_POOL_MODULE_NAME}/${VOIP_NUMBER_POOL_RESERVE_NUMBER_ACTION}`
} as const;

export const VoipNumberPoolStoreMutations = {
	CLEAR: `${VOIP_NUMBER_POOL_MODULE_NAME}/${VOIP_NUMBER_POOL_CLEAR_STATE}`,
	SET_PROVINCE: `${VOIP_NUMBER_POOL_MODULE_NAME}/${VOIP_NUMBER_POOL_SET_PROVINCE}`
} as const;

export const VoipNumberPoolStoreGetters = {
	GET_PREFIXES: `${VOIP_NUMBER_POOL_MODULE_NAME}/${VOIP_NUMBER_POOL_GET_PREFIXES}`
} as const;
